import { useMemo } from "react";

import { DocumentTreeClassControl } from "@/Common/Helpers/DocumentTreeClassControl";
import { DocumentClass, DocumentSubClassResults } from "@/Common/Resources/Lookups/Enums/DocumentClasses";

interface ResultCategoriesDropdownProps {
    categoryLookupId: string;
    onChange: (selectedCategoryLookupId: string) => void;
    className?: string;
    dataCy?: string;
    id: string;
}

function ResultCategoriesDropdown({ id, categoryLookupId, onChange, className, dataCy }: Readonly<ResultCategoriesDropdownProps>): JSX.Element {
    const resultCategories = useMemo(() => DocumentTreeClassControl.getDocClassFromLookup(DocumentClass.Results, DocumentSubClassResults.Code), []);
    const subClasses = useMemo(() => resultCategories.SubClasses.toArray(), [resultCategories]);
    return (
        <select
            className={`form-control myle-control ${className}`}
            onChange={event => onChange(event.target.value)}
            value={categoryLookupId}
            data-cy={dataCy}
            id={id}
        >
            <option value="" />
            {subClasses.map(item => (
                <option
                    key={item.LookupId}
                    value={item.LookupId}
                >
                    {`${cacheStore.GetLocalizedValueByLookupId(resultCategories.LookupId)} - ${cacheStore.GetLocalizedValueByLookupId(item.LookupId)}`}
                </option>
            ))}
        </select>
    );
}

export { ResultCategoriesDropdown };
